import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";

const AddNewAccount = ({ show, hide, title, getAccountList }) => {
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const addNewAccount = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    userData.description = description
    let data = await accountServices.addNewAccount(userData)
    if (data?.statusCode === 200) {
      getAccountList()
      clearData();
    }
    setLoader(false)
  }

  const clearData = () => {
    setName("");
    setDescription("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setDescription("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Account Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="accountName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Account Name "
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Description (optional)</Form.Label>
            <Form.Control
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Description (optional)"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button onClick={addNewAccount} style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddNewAccount;
